/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { Button } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios } from "~/tools";

export function DownloadReport() {
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const onSubmit = async () => {
    try {
      const { data } = await Axios().get("/onboarding-status?format=csv");
      const url = window.URL.createObjectURL(new Blob([data.toString()]));
      const link = document.createElement("a");
      // eslint-disable-next-line fp/no-mutation
      link.href = url;
      link.setAttribute("download", "report.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (e) {
      showError(e.response);
    }
  };
  const { handleSubmit } = useForm();

  return (
    <>
      <Button
        severity="low"
        icon="export"
        css={{ marginLeft: "1rem" }}
        onClick={handleSubmit(onSubmit)}
      >
        Report
      </Button>
    </>
  );
}
